import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=1dbbe3da&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=ts&"
export * from "./payment.vue?vue&type=script&lang=ts&"
import style0 from "./payment.vue?vue&type=style&index=0&id=1dbbe3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbbe3da",
  null
  
)

export default component.exports